import { InternationalReturnPricing } from "@redotech/redo-model/team";

export function getAllReturnEligibleCountries(
  countries: string[],
  internationalPricing: InternationalReturnPricing | null | undefined,
): string[] {
  if (!internationalPricing?.length || !countries.length) {
    return countries;
  }

  if (internationalPricing.find((pricing) => pricing.countries.length === 0)) {
    return [];
  }

  return countries.concat(
    internationalPricing.map((price) => price.countries).flat(),
  );
}

export function getInternationalPrice(
  price: number,
  country: string,
  domesticCountries: string[],
  internationalPricing: InternationalReturnPricing,
) {
  if (
    domesticCountries.includes(country) ||
    !domesticCountries.length ||
    !internationalPricing.length
  ) {
    return price;
  }

  let mult = internationalPricing.find((pricing) =>
    pricing.countries.includes(country),
  )?.multiplier;

  if (!mult) {
    mult =
      internationalPricing.find((pricing) => pricing.countries.length === 0)
        ?.multiplier || 1;
  }
  return price * mult;
}
